// Third-party libraries
import React from "react";

// Local modules
import HomeContent from "./static/HomeContent";

export default function Home() {
  return <HomeContent />;
}
